export default {
  name: 'ACCOUNTEXPORT',
  auto: ['actions'],
  storeKey: 'accountExport',
  serviceName: 'accountExport',
}



// WEBPACK FOOTER //
// ./src/store/modules/accountExport.js